import(/* webpackMode: "eager" */ "/Users/gokmenkarasu/Desktop/Claude/album-reviews/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/Users/gokmenkarasu/Desktop/Claude/album-reviews/node_modules/next/dist/client/image-component.js");
